<template>
  <Authenticated>
    <form v-on:submit.prevent="setup">
      <h1> Welcome to Beamy</h1>
      <h3>Before you can proceed you will need create a site</h3>
      <p>This is the place you operate, i.e. 'city' or 'trailer'</p>
      <p>You can create additional sites once you have created one site</p>
      <h2>Site name:</h2>
      <input name="site" v-model="site" placeholder="Site" autofocus autocomplete="site" />
      <div class="error" v-if="errors && errors.site">Site {{ errors.site.join(", ") }}</div>
      <div class="error" v-if="errors && errors.all">{{ errors.all }}</div>
      <button type="submit" value="Create Company Up">Create Site</button>
    </form>
  </Authenticated>
</template>

<script>
import Authenticated from "@/components/_layouts/Authenticated.vue";
import { api } from "@monolith/helpers";
import { mapGetters } from "vuex";
import Slug from "slug";

export default {
  name: "Login",
  components: { Authenticated },
  data() {
    return {
      errors: {},
      site: null,
    };
  },
  computed: {
    ...mapGetters({
      company: "companyName",
    }),
  },
  methods: {
    async setup() {
      this.errors = {};
      let result = await api.add_site(Slug(this.site));
      if ("ok" in JSON.parse(result)) {
        await this.$store.dispatch("getAllData");
        this.$router.push({ path: "/dashboard" });
      }
    },
  },
};
</script>

<style scoped lang="scss">
form {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;
  border-radius: 0.5rem;
  width: 25%;
  padding: 3rem;
  background-color: var(--primary-colour);
  margin: auto;
  img {
    width: 100%;
  }
  p {
    margin: 0.25rem;
  }
  h1 {
    color: var(--action-colour);
  }
  svg {
    width: 25rem;
    border-radius: 10px;
  }

  .cls-1 {
    fill: var(--action-colour);
  }

  input {
    box-sizing: border-box;
    border-radius: 5px;
    border: none;
    padding: 1rem;
    width: 100%;
    margin-bottom: 1rem;
    background-color: var(--tertiary-colour);
    box-shadow: var(--box-shadow);
  }
  button {
    margin: 0 0 1rem 0;
    width:100%;
    background-color: var(--action-colour);
    color: var(--secondary-text-colour);
  }
  button.secondary {
    background-color: orange;
  }
}

form div.error {
  display: block;
  margin-bottom: 1em;
  color: #ff003b;
  padding-left: 1rem;
}

.password {
  display: block;
  text-align: right;
  margin-top: 10px;
}

@media screen and (max-width: 720px) {
  form {
    padding: 1rem;
    min-width: 80%; 
    max-width: 100% !important;
  }
}
</style>
